import React, {
  useEffect,
  useState,
} from "react";

import axios from "axios";

import "./Preference.css";

const PreferencesPage = () => {

  const [loading, setLoading] =
    useState(true);

  const [saving, setSaving] =
    useState(false);

  const [invalidToken, setInvalidToken] =
    useState(false);
  const [inviteType, setInviteType] =
  useState("");
  const [preferences, setPreferences] =
    useState({

      emailOptOut: false,

      smsOptOut: false,

      whatsappOptOut: false,
    });

  /**
   * GET TOKEN
   */

  const token = new URLSearchParams( window.location.search).get("token");

  /**
   * FETCH PREFERENCES
   */

  useEffect(() => {

    fetchPreferences();

  }, []);

  const fetchPreferences = async () => {

    try {

      const response =
        await axios.get(

          `${process.env.REACT_APP_SERVER_URL}/api/sms/preferences?token=${token}`
        );

      setPreferences(
        response.data.data
      );
      console.log("Invite Type:", response.data);
      setInviteType(response.data.data.type);

    } catch (error) {

      setInvalidToken(true);

    } finally {

      setLoading(false);
    }
  };

  /**
   * HANDLE TOGGLE
   */

  const handleToggle = (field) => {

    setPreferences((prev) => ({

      ...prev,

      [field]: !prev[field],
    }));
  };

  /**
   * SAVE PREFERENCES
   */

  const handleSave =
    async () => {

      try {

        setSaving(true);

        const payload = {};

/**
 * EMAIL USER
 */

if (inviteType === "email") {

  payload.emailOptOut =
    preferences.emailOptOut;
}

/**
 * SMS / WHATSAPP USER
 */

else {

  payload.smsOptOut =
    preferences.smsOptOut;

  payload.whatsappOptOut =
    preferences.whatsappOptOut;
}

await axios.put(

  `${process.env.REACT_APP_SERVER_URL}/api/sms/preferences?token=${token}`,

  payload
);

        alert(
          "Preferences updated successfully"
        );

      } catch (error) {

        alert(
          "Failed to update preferences"
        );

      } finally {

        setSaving(false);
      }
    };

  /**
   * INVALID TOKEN
   */

  if (invalidToken) {

    return (

      <div className="preferences-page">

        <div className="preferences-card">

          <h2>
            Invalid or expired link
          </h2>

        </div>

      </div>
    );
  }

  /**
   * LOADING
   */

  if (loading) {

    return (

      <div className="preferences-page">

        <div className="preferences-card">

          <h2>
            Loading preferences...
          </h2>

        </div>

      </div>
    );
  }

  return (

  <div className="preferences-page">

    <div className="preferences-card">

      <div className="logo-section">

        <h1>
          Medhas AI
        </h1>

        <p>
          Notification Preferences
        </p>

      </div>

      {/* EMAIL */}

      <div
        className={`preference-item ${
          inviteType !== "email"
            ? "disabled-pref"
            : ""
        }`}
      >

        <div>

          <h3>
            Email Notifications
          </h3>

          <p>
            Receive invitations,
            updates and emails.
          </p>

        </div>

        <label className="switch">

          <input
            type="checkbox"

            checked={
              !preferences.emailOptOut
            }

            disabled={
              inviteType !== "email"
            }

            onChange={() =>
              handleToggle(
                "emailOptOut"
              )
            }
          />

          <span className="slider"></span>

        </label>

      </div>

      {/* SMS */}

      <div
        className={`preference-item ${
          inviteType !== "sms"
            ? "disabled-pref"
            : ""
        }`}
      >

        <div>

          <h3>
            SMS Notifications
          </h3>

          <p>
            Receive SMS alerts and
            notifications.
          </p>

        </div>

        <label className="switch">

          <input
            type="checkbox"

            checked={
              !preferences.smsOptOut
            }

            disabled={
              inviteType !== "sms"
            }

            onChange={() =>
              handleToggle(
                "smsOptOut"
              )
            }
          />

          <span className="slider"></span>

        </label>

      </div>

      {/* WHATSAPP */}

      <div
        className={`preference-item ${
          inviteType !== "whatsapp"
            ? "disabled-pref"
            : ""
        }`}
      >

        <div>

          <h3>
            WhatsApp Notifications
          </h3>

          <p>
            Receive WhatsApp
            updates and messages.
          </p>

        </div>

        <label className="switch">

          <input
            type="checkbox"

            checked={
              !preferences.whatsappOptOut
            }

            disabled={
              inviteType !== "whatsapp"
            }

            onChange={() =>
              handleToggle(
                "whatsappOptOut"
              )
            }
          />

          <span className="slider"></span>

        </label>

      </div>

      <div className="button-group">

        <button

          className="save-btn"

          onClick={handleSave}

          disabled={saving}
        >

          {
            saving
              ? "Saving..."
              : "Save Preferences"
          }

        </button>

      </div>

    </div>

  </div>
);
};

export default PreferencesPage;